export default {
  methods: {
    validateField(field, text, length = -1, fieldType = "input") {
      let massages = {
        input: "وارد کنید",
        select: "انتخاب کنید",
        radio: "انتخاب کنید",
        checkbox: "انتخاب کنید",
      };
      if (
        !field ||
        field == {} ||
        field == null ||
        field.toString().trim().length === 0
      ) {
        return "لطفا " + text + " را " + massages[fieldType];
      } else if (field.toString().trim().length < length) {
        return `${text} باید حداقل شامل ${length} حرف باشد`;
      } else {
        return null;
      }
    },

    checkNumberFormat(event) {
      let char = String.fromCharCode(event.keyCode);
      if (/^[0-9۰-۹]+$/.test(char)) {
        return true;
      } else {
        event.preventDefault();
      }
    },

    validateEmail(email) {
      if (email === undefined || email === "" || email == null) {
        return "لطفا ایمیل را وارد کنید";
      } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(email)) {
        return "ایمیل وارد شده معتبر نمی باشد";
      } else {
        return null;
      }
    },

    validateEmailFormat(email) {
      if (email && !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(email)) {
        return "ایمیل وارد شده معتبر نمی باشد";
      } else {
        return null;
      }
    },

    validatePhoneNumber(value) {
      if (value === undefined || value === null || value === "") {
        return "لطفا شماره موبایل را وارد کنید";
      } else if (
        !/^(?:(\u0660\u0669[\u0660-\u0669][\u0660-\u0669]{8})|(\u06F0\u06F9[\u06F0-\u06F9][\u06F0-\u06F9]{8})|(09[0-9][0-9]{8}))$/.test(
          value
        )
      ) {
        return "شماره موبایل وارد شده معتبر نمی باشد";
      } else {
        return null;
      }
    },

    validatePassword(pwd) {
      if (pwd == null || pwd.toString().trim() === "") {
        return "لطفا کلمه عبور را وارد کنید";
      } else if (pwd.toString().trim().length < 6) {
        return "کلمه عبور حداقل باید شامل 6 کاراکتر باشد";
      } else {
        return null;
      }
    },

    validateUsername(username) {
      if (username === undefined || username === null || username === "") {
        return "لطفا ایمیل یا شماره موبایل را وارد کنید";
      } else if (
        !this.validateEmail(username) ||
        !this.validatePhoneNumber(username)
      ) {
        return null;
      } else {
        return "ایمیل یا شماره موبایل وارد شده معتبر نمی باشد";
      }
    },

    validateUrl(field, text) {
      const expression =
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$"; // fragment locator
      const regexp = new RegExp(expression, "i");

      if (regexp.test(field) || field === "" || field == null) {
        return null;
      } else {
        return "" + text + " وارد شده معتبر نیست.";
      }
    },

    validateImageSize(file) {
      let size = parseFloat(file.size / 1024).toFixed(2);
      if (size > 500) {
        return {
          validate: false,
          message: this.$t(`${this.I18nPrefix}SIZE_IMAGE_ERROR`),
        };
      }
      return {
        validate: true,
        message: null,
      };
    },

    validateImageFormat(file) {
      if (typeof file != "undefined") {
        let suffix = file.name
          .substring(file.name.lastIndexOf("."))
          .replace(".", "");
        let allowSuffixes = ["jpg", "png", "jpeg", "gif", "svg", "bmp", "tiff"];
        if (!allowSuffixes.includes(suffix)) {
          return {
            validate: false,
            message: this.$t(`${this.I18nPrefix}FORMAT_IMAGE_ERROR`),
          };
        }
        return {
          validate: true,
          message: null,
        };
      }
    },
  },
};
